export enum adminAdministratorsDeleteTypes {
    FETCH_ADMIN_ADMINISTRATORS_DELETE_REQUEST = "FETCH_ADMIN_ADMINISTRATORS_DELETE_REQUEST",
    FETCH_ADMIN_ADMINISTRATORS_DELETE_SUCCESS = "FETCH_ADMIN_ADMINISTRATORS_DELETE_SUCCESS",
    FETCH_ADMIN_ADMINISTRATORS_DELETE_FAILURE = "FETCH_ADMIN_ADMINISTRATORS_DELETE_FAILURE",
  }